import {
	ConfigurationDataSourceType,
	ConfigurationRow,
} from '@Types/configurations.types';
import { PhysicalDataSourceType } from './constants';
import { Resolutions } from '@innovyze/stylovyze';

export const isNonDeletableConfiguration = (dataSourceType?: string) => {
	return (
		dataSourceType === ConfigurationDataSourceType.CUSTOM_ANALYTICS ||
		dataSourceType === ConfigurationDataSourceType.MASS_BALANCE ||
		dataSourceType === ConfigurationDataSourceType.ILI ||
		dataSourceType === ConfigurationDataSourceType.EMAGIN
	);
};

export const isVirtualSensor = (dataSourceType?: string) => {
	return (
		dataSourceType === ConfigurationDataSourceType.CUSTOM_ANALYTICS ||
		dataSourceType === ConfigurationDataSourceType.MASS_BALANCE ||
		dataSourceType === ConfigurationDataSourceType.ILI
	);
};

const isNumber = (number: unknown) => {
	return typeof number === 'number' && !isNaN(number);
};

export const generateConfigurationCoords = (
	longitude: number | undefined,
	latitude: number | undefined,
) => {
	return longitude && isNumber(longitude) && latitude && isNumber(latitude)
		? [longitude, latitude]
		: [];
};

export const getDataSourceType = (type: string) => {
	return Object.values(PhysicalDataSourceType).includes(
		type as PhysicalDataSourceType,
	)
		? 'physical'
		: type;
};

export const createRowID = (config: ConfigurationRow) => {
	const dataSourceType = config.dataSourceType
		? getDataSourceType(config.dataSourceType)
		: config.sourceType
		? getDataSourceType(config.sourceType)
		: 'physical';

	return `${dataSourceType}_#_${config._id}_#_${config.sensorId}`;
};

export const getSensorChartResolution = (
	dataSourceType?: string,
	configResolution?: string,
) => {
	if (
		dataSourceType === ConfigurationDataSourceType.ILI ||
		dataSourceType === ConfigurationDataSourceType.MASS_BALANCE
	)
		return Resolutions.DAILY;
	if (dataSourceType === ConfigurationDataSourceType.CUSTOM_ANALYTICS) {
		switch (configResolution) {
			case '15 minute':
				return Resolutions['15-MINUTE'];
			case '30 minute':
				return Resolutions['30-MINUTE'];
			case '1 hour':
				return Resolutions.HOURLY;
			case '1 day':
				return Resolutions.DAILY;
			case '1 week':
				return Resolutions.WEEKLY;
			default:
				return Resolutions['15-MINUTE'];
		}
	}
	return Resolutions.RAW;
};

export const decodeToUtf8 = (fileBuffer: ArrayBuffer) => {
	const decoder = new TextDecoder('utf8', { fatal: true, ignoreBOM: true });
	return decoder.decode(fileBuffer);
};
